import {
  PencilSquareIcon,
  ListBulletIcon,
  AdjustmentsHorizontalIcon,
} from "@heroicons/react/24/outline";
import { PlusIcon } from "@heroicons/react/16/solid";
import Button from "../../../../../componentLibrary/Button";
import { QUESTION_TYPE_LABELS } from "../utils/questionUtils";

const QUESTION_TYPE_ICONS: Record<
  string,
  React.ComponentType<{ className?: string }>
> = {
  input: PencilSquareIcon,
  multiple_choice: ListBulletIcon,
  rating_scale: AdjustmentsHorizontalIcon,
};

export default function QuestionTypeList({
  onAdd,
}: {
  onAdd: (type: string) => void;
}) {
  return (
    <div className="flex flex-col h-full">
      <h3 className="text-sm font-semibold text-gray-700 mb-3">
        Question Types
      </h3>
      <div className="space-y-1">
        {Object.entries(QUESTION_TYPE_LABELS).map(([type, label]) => {
          const Icon = QUESTION_TYPE_ICONS[type] ?? PencilSquareIcon;
          return (
            <div
              key={type}
              className="flex items-center justify-between px-2 py-1.5 rounded hover:bg-gray-50"
            >
              <div className="flex items-center gap-2">
                <Icon className="w-4 h-4 text-gray-500" />
                <span className="text-sm text-gray-700">{label}</span>
              </div>
              <Button variant="dark" size="sm" onClick={() => onAdd(type)}>
                <PlusIcon className="w-4 h-4" />
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
